import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { SyncService } from '../../sync.service';
import { animate, style, transition, trigger } from '@angular/animations';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Component({
	selector: 'submit-deal',
	templateUrl: './submit-deal.component.html',
	styleUrls: ['./submit-deal.component.css'],
	encapsulation: ViewEncapsulation.None,
	animations: [
		trigger('fadeIn', [
			transition(':enter', [
				style({ opacity: 0}),
				animate('125ms ease-in', style({ opacity: 1 }))
			]),
			transition(':leave', [
				animate('125ms ease-out', style({ opacity: 0}))
			])
		]),
		trigger('fadeInUp', [
			transition(':enter', [
				style({ opacity: 0, transform: 'translateY(-2px)' }),
				animate('125ms ease-in', style({ opacity: 1, transform: 'translateY(0)' }))
			]),
			transition(':leave', [
				animate('125ms ease-out', style({ opacity: 0, transform: 'translateY(2px)' }))
			])
		])
	]
})
export class SubmitDealComponent implements OnInit {
	userData: any;
	currentDealName: any;
	validateUrl = environment.validateUrl;
	constructor(
		private syncService: SyncService,
		private http: HttpClient
	) { }
	ngOnInit(): void {
		if (this.syncService.authStatus.getValue() !== 'authenticated') {
			this.syncService.updateAuthStatus('unauthenticated');
			this.syncService.updatePage('login');
			return;
		}
		this.syncService.userData$.subscribe((userData) => {
			this.userData = userData;
		});
		this.syncService.currentDeal$.subscribe((currentDeal) => {
			this.currentDealName = currentDeal;
			if (!this.currentDealName && this.userData['Deals']) {
				this.currentDealName = this.userData['Deals'][0]['Deal Name'];
			}
		});
	}
	onDealSelected(deal: any) {
		this.currentDealName = deal;
	}

	submitDeal() {
		this.syncService.updateNotificationType('success');
		this.syncService.updateNotificationTitle('We\'ll start pricing ' + this.currentDealName + ' shortly.');
		this.syncService.updateNotificationSubtitle('We\'ll notify you once the process is complete.');
		this.syncService.updateShowNotification(true);
		const formData: FormData = new FormData();
		formData.append('Email', this.userData['Email']); // DONE
		formData.append('Deal Name', this.currentDealName);
		const headers = new HttpHeaders();
		this.http.post(this.validateUrl, formData, { headers }).subscribe();
		setTimeout(() => {
			this.syncService.updateShowNotification(false);
		}, 5000);
	}

}
